import {Tab} from '../../../../../../modules/index.esm';
import {VGSidebar} from "vgnav/src/VGSidebar";

window.VegasCatalog = {
	popup: function (text, params = {}) {
		let defaults = {
			"positionClass": "toast-bottom-center",
			'preventDuplicates': true
		};

		Toastr.options = Object.assign(defaults, params);
		Toastr.success(text);
	}
};

require('./_order');
require('./_order_confirm');
require('./_input-counter');
require('./_product');
require('./_product_options');
require('./_cart');
require('./_compare');
require('./_fav');
require('./_filters');
require('./_waiting_list');
require('./rent/rent');

$("#catalog-filter-form").submit(function () {
	let route = $(this).attr('action');
	let params = $(this).serializeArray();
	let $panelFilters = $('#filters-panel');

	if ($panelFilters.length) {
		let $btnSubmit = $panelFilters.find('.catalog-filters__submit');
		$btnSubmit.attr('disabled', false);
		$btnSubmit.text('Фильтровать');
	}

	$.ajax({
		data: params,
		url: route,
		headers: {"X-Ajax-Catalog": 1},
		beforeSend: function () {
			$('.products-container').addClass('loading');
		},
		success: function (data) {
			let $prdContainer = $('.products-container');

			$prdContainer.html(data.view_catalog);
			$prdContainer.removeClass('loading')

			history.pushState({}, '', data.url);

			VegasCatalog.Filters.setApplied();

			if ($panelFilters.length) {
				let $btnSubmit = $panelFilters.find('.catalog-filters__submit');

				if ('products_count' in data) {
					if (data.products_count > 0) {
						$btnSubmit.text('Показать '+ data.products_count + ' ' + getWordForm(data.products_count, ['товар', 'товара', 'товаров']));
						$btnSubmit.attr('disabled', false);
					} else {
						$btnSubmit.text('Ничего не найдено');
						$btnSubmit.attr('disabled', true);
					}
				} else {
					$btnSubmit.text('Фильтровать')
				}

				$btnSubmit.click(function () {
					let $sidebar = new VGSidebar('#filters-panel');
					$sidebar.close({}, true);

					return false;
				});
			}
		}
	});

	return false;
});

$('[data-toggle="show-all-params"]').click(function () {
	$([document.documentElement, document.body]).animate({
		scrollTop: $("#product-tabsContent").offset().top - 60
	}, 100);

	const triggerEl = document.querySelector('#product-tabs button[data-bs-target="#characteristics-tab-pane"]');
	new Tab(triggerEl).show()

	return false;
});
